import * as React from 'react';
import {withStyles} from "@material-ui/core";
import {WithStyles} from "@material-ui/core/styles";
import CheckIcon from '@material-ui/icons/Check';
import TranslateNew from "@translate/TranslateNew";
import { EditActionStyle } from '../EditAction.style';
import { IScheduleTemplate, TemplateName } from '@app-types/websocket/schedule.types';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof EditActionStyle> {
    template: IScheduleTemplate;
    selected:boolean;
    colorA: string;
    colorB: string;
    monthView?: boolean;
    localization: 'se'|'en';
    onDayClick?: (day: number) => void | undefined;
    onSelectTemplate: (template:IScheduleTemplate) => void;
}

interface IState {
    expanded:boolean;
}

class TemplateCalendar extends React.Component<IProps, IState> {

    constructor(props: any) {
        super(props);
        this.state = {
            expanded:false,
        }
    }

    public render() {
        const {classes: style, template, selected, colorA, colorB, monthView, onDayClick,} = this.props;

        const days:JSX.Element[] = [];
        const daysToGenerate = monthView?35:template.days.length;

        for (let index = 0; index < daysToGenerate; index++) {
            const night = template.days[(index-(this.props.localization==="en"?1:0))%template.days.length];
            days.push(<div
                key={index}
                className={style.templateCalendarDay}
                style={{cursor: (onDayClick ? 'pointer' : 'default'), backgroundColor: ((night === "A")? colorA : colorB)}}
                onClick={(event) => onDayClick ? onDayClick(index) : undefined}
            />);
        }


        return (
            <div style={{borderBottom: '1px solid #ccc', paddingBottom: '8px'}}>
                <div className={style.templateTitle} onClick={() => this.props.onSelectTemplate(template)}>
                    <CheckIcon style={{opacity:selected?1:0}} className={style.checkIcon} />
                    <div>{tn.lang.calendarTemplateName(template.title)}</div>
                </div>
                <div className={style.templateHideCalendar} style={(this.state.expanded || selected)?{maxHeight:160}:{maxHeight:0, opacity:0}}>
                    {template.title === TemplateName.CUSTOM
                        ?<div style={{padding: '10px 34px'}}>{tn.lang.calWizardCustomExplain}</div>
                        :<>
                            <div style={{marginLeft: '34px', fontSize: '11px', fontWeight: 300}}>
                                {template.type==="AlternatingResidence"?tn.lang.calWizardEven:tn.lang.calWizardUneven}
                            </div>
                            <div className={style.templateCalendar}>{days}</div>
                        </>}
                </div>
            </div>);
    }
}

export default withStyles(EditActionStyle)(TemplateCalendar);



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/editActions/Wizard/TemplateExample.tsx